import { FC } from "react";

import { IconView } from "@/components/_molecules/icon-picker/icon-view";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { cn } from "@/lib/cn";

interface FocusAreaViewEmptyProps {
  logoOnly?: boolean;
  canWrapLabel?: boolean;
  className?: string;
}

export const FocusAreaViewEmpty: FC<FocusAreaViewEmptyProps> = ({ ...props }) => {
  const { t } = useDomainTranslation("focus-area");

  return (
    <div className={cn(["flex flex-row items-center gap-2", props.canWrapLabel && "min-w-0"])}>
      <IconView className={cn(["h-5 w-5 shrink-0", props.className])} />
      {!props.logoOnly && (
        <div className={cn(["text-xs font-normal", props.canWrapLabel ? "break-words" : "whitespace-nowrap"])}>
          {t("noFocusArea")}
        </div>
      )}
    </div>
  );
};

export default FocusAreaViewEmpty;
